import { defaultShouldDehydrateQuery, QueryClient } from '@tanstack/react-query';
import SuperJSON from 'superjson';
import { getErrorType } from './error-utils';

// Error types that should not be retried (deterministic failures)
const NON_RETRYABLE_ERROR_TYPES = ['TOKEN_EXPIRED', 'BAD_REQUEST'] as const;

function shouldRetry(failureCount: number, error: unknown): boolean {
  const errorType = getErrorType(error);
  if (
    errorType &&
    NON_RETRYABLE_ERROR_TYPES.includes(errorType as (typeof NON_RETRYABLE_ERROR_TYPES)[number])
  ) {
    return false;
  }
  return failureCount < 3;
}

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 30 * 1000,
        retry: shouldRetry,
      },
      dehydrate: {
        serializeData: SuperJSON.serialize,
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
        shouldRedactErrors: () => {
          // We should not catch Next.js server errors
          // as that's how Next.js detects dynamic pages
          // so we cannot redact them.
          // Next.js also automatically redacts errors for us
          // with better digests.
          return false;
        },
      },
      hydrate: {
        deserializeData: SuperJSON.deserialize,
      },
    },
  });
